import React from 'react';

// Styles & Assets
import styles from './CasesTable.module.css';

// Components
import Table from '../../UI/Table/Table';

// Interface
import { CaseHistory } from '../../../interfaces/Patient';
import { Column } from '../../../interfaces/Columns';
import { IColumnOrder } from '../../../interfaces/UtilInterfaces';
interface Props {
    columns: Column<CaseHistory>[]
    historicCases: CaseHistory[]
    columnOrder: IColumnOrder
    setColumnOrder: React.Dispatch<React.SetStateAction<IColumnOrder>>
}

// Constants
const CasesTable: React.FC<Props> = ({
    columns,
    historicCases,
    columnOrder,
    setColumnOrder,
}) => {

    return (
        <div className={styles.tableContainer}>
            <Table
                columns={columns}
                rows={historicCases}
                nohoverRow
                preventSort
                defaultColumnToOrder={[columnOrder, setColumnOrder]}
                setColorRow={() => '#eee'}
            />
        </div>
    );
};

export default CasesTable;